import { useWorkflow } from '@/hooks/useWorkflow';
import { ActivationsResponse } from '@/types/ActivationResponse';
import tap from '@assets/tap.svg';
import { UiTapCardKeyLined } from '@cof/omni-gravity-icons-react';
import { Button, Container, Flex, Icon, TextBody } from '@cof/omni-react';
import {
  AbsolutePosition,
  AbsolutePositionCenter,
  RoundedButton,
} from '@components/global';
import { PullDialog } from '@components/PullDialog';

interface ActivateCardProps {
  setReadyToActivate: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ActivateCard = ({ setReadyToActivate }: ActivateCardProps) => {
  const { templateJson, reqUrl } = useWorkflow();

  const {
    merchantName,
    merchantImage,
    merchantImageAlt,
    cardImage,
    cardImageAlt,
  } = templateJson as ActivationsResponse;

  const onActivateCard = () => {
    setReadyToActivate(true);
  };

  return (
    <Container data-testid="ActivateCard--container">
      <PullDialog
        aria-labelledby="activate-card-label"
        aria-describedby="activate-card-desc"
      >
        <Container style={{ padding: '0 1rem' }}>
          <TextBody
            variant="huge"
            textAlign={'center'}
            fontWeight="semibold"
            id="activate-card-label"
            stack="huge"
          >
            Take out your new card
          </TextBody>
          <Flex direction={'column'} position={'relative'} stack={'huge'}>
            <img
              src={`${reqUrl}${cardImage}`}
              alt={cardImageAlt}
              role="presentation"
              width="100%"
            />
            <Flex>
              <AbsolutePositionCenter as={TextBody} color={'inverse'}>
                {merchantName}
              </AbsolutePositionCenter>
              <AbsolutePosition
                as={Flex}
                bottom={'1.5rem'}
                left={'1.5rem'}
                style={{ gap: '0.5rem' }}
              >
                <img src={tap} alt="tap card icon" role="presentation" />
                <Icon svg={UiTapCardKeyLined} color="inverse" size={19} />
              </AbsolutePosition>
              <AbsolutePosition bottom={'1.5rem'} right={'1rem'}>
                <img
                  src={`${reqUrl}${merchantImage}`}
                  width="55"
                  alt={merchantImageAlt}
                  role="presentation"
                />
              </AbsolutePosition>
            </Flex>
          </Flex>
          <TextBody
            textAlign={'center'}
            style={{ padding: '0 1rem' }}
            stack={'huge'}
            aria-describedby="activate-card-desc"
          >
            To activate your card, tap Start and then touch the card to this
            device.
          </TextBody>
          <Flex direction={'column'} gap={'medium'}>
            <RoundedButton
              btnVariant="primary"
              displayText="Tap Card to Activate"
              onClickCallback={() => onActivateCard()}
            />
            <Button
              type="button"
              variant={'action'}
              rank={'tertiary'}
              style={{ color: '#011728' }}
              onClick={() => console.log('CVV clicked')}
            >
              Enter CVV
            </Button>
          </Flex>
        </Container>
      </PullDialog>
    </Container>
  );
};
